<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="note information"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Subject" label-position="inside">
                        <b-input maxlength="300" v-model="note.subject"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Note" label-position="inside">
                        <b-input type="textarea" v-model="note.note"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";

    export default {
        name: 'TripNoteForm',
        props: {
            note: {
                type: Object,
                required: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList}
    };
</script>
